export const TX_VALIDATOR_REWARDS_WITHDRAW_AMOUNT_SET = 'TX_VALIDATOR_REWARDS_WITHDRAW_AMOUNT_SET';
export const TX_VALIDATOR_REWARDS_WITHDRAW_SHOW = 'TX_VALIDATOR_REWARDS_WITHDRAW_SHOW';
export const TX_VALIDATOR_REWARDS_WITHDRAW_HIDE = 'TX_VALIDATOR_REWARDS_WITHDRAW_HIDE';
export const TX_VALIDATOR_REWARDS_WITHDRAW_MEMO_SET = 'TX_VALIDATOR_REWARDS_WITHDRAW_MEMO_SET';